import ReactOnRails from 'react-on-rails';
import ChatOverlay from '../bundles/ChatOverlay/components/ChatOverlay';

// Register the ChatOverlay component with ReactOnRails
ReactOnRails.register({
  ChatOverlay,
});

// This file is the entry point for the ChatOverlay bundle
// It will be compiled by Webpack and included in the page 